import { StepBackButton } from 'pages/AppointmentsReserve/components/ui/StepBackButton';
import { StepNextButton } from 'pages/AppointmentsReserve/components/ui/StepNextButton';
import { type Employee } from 'types/employees';
import { PatientCard } from '../PatientCard';

interface SelectedPatientViewProps {
  patient: Employee;
  onBack: () => void;
  onNext: () => void;
}

export const SelectedPatientView = ({
  patient,
  onBack,
  onNext,
}: SelectedPatientViewProps): React.ReactElement => (
  <div className="flex w-full flex-col gap-10">
    <PatientCard patient={patient} />
    <div className="flex w-full justify-between">
      <StepBackButton onClick={onBack} />
      <StepNextButton onClick={onNext} />
    </div>
  </div>
);
